<template>
    <v-sheet v-if="fees && Object.values(fees).length">
        <v-layout v-for="(value, name) in fees" :key="`fee-${value}`">
            <v-flex xs6>
                <span>{{name}}</span>
            </v-flex>
            <v-flex xs6 class="text-xs-right">
                <v-sheet>
                    {{value | currency}}
                </v-sheet>
            </v-flex>
        </v-layout>
    </v-sheet>
</template>

<script>
    export default {
        name: 'ProductFees',
        props: [
            'fees',
        ],
    };
</script>